import { render } from "./CloudWarehouse.vue?vue&type=template&id=22fa3fe2&scoped=true"
import script from "./CloudWarehouse.vue?vue&type=script&lang=js"
export * from "./CloudWarehouse.vue?vue&type=script&lang=js"

import "./CloudWarehouse.vue?vue&type=style&index=0&id=22fa3fe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fa3fe2"]])

export default __exports__